import type { AppService } from '@/core/http/http-client'
import type { ResponseApi } from '@/core/http/response-api'
import type { ResponseResult } from '@/core/http/response-result'
import { ApiError, ErrorUtil } from '@/core/http/response_error'
import type { AuthPort } from '@/features/signin/application/ports/auth_port'
import type { AuthUserToken } from '@/features/signin/domains/auth_user_token'
import type { Credential } from '@/features/signin/domains/credential'
import type { AuthUser } from '../../domains/auth_user'
import type { AuthUserTokenEntity, UserEntity } from '../entity/auth_user_token_entity'
import { AuthUserMapper } from '../mappers/auth_user_mapper'
import { CrendentialMapper } from '../mappers/credential_mapper'

export class AuthRepository implements AuthPort {
  constructor(private httpClient: AppService) {}

  async login(payload: Credential): Promise<ResponseResult<AuthUserToken>> {
    try {
      const data = CrendentialMapper.toEntity(payload)
      const result = await this.httpClient.post<ResponseApi<AuthUserTokenEntity>>('/login', data)
      const response = result.data
      if (result.status == 200) {
        if (response.STATUS_CODE == 1) {
          return {
            STATUS_CODE: response.STATUS_CODE,
            DATA: AuthUserMapper.toDomain(response.DATA!),
          }
        } else {
          throw new ApiError({
            message: response.MESSAGE!,
            bizCode: response.STATUS_CODE,
            statusCode: result.status,
          })
        }
      } else {
        throw new ApiError({
          message: 'Ocurrio un problema.!',
          bizCode: response.STATUS_CODE,
          statusCode: result.status,
        })
      }
    } catch (error: unknown) {
      throw ErrorUtil.getError(error)
    }
  }

  async me(payload: string): Promise<ResponseResult<AuthUser>> {
    try {
      const result = await this.httpClient.post<ResponseApi<UserEntity>>('/me', {
        token: payload,
      })
      const response = result.data
      if (result.status == 200) {
        if (response.STATUS_CODE == 1) {
          return {
            STATUS_CODE: response.STATUS_CODE,
            DATA: AuthUserMapper.toDomainUser(response.DATA!),
          }
        } else {
          throw new ApiError({
            message: response.MESSAGE!,
            bizCode: response.STATUS_CODE,
            statusCode: result.status,
          })
        }
      } else {
        throw new ApiError({
          message: 'Ocurrio un problema.!',
          bizCode: response.STATUS_CODE,
          statusCode: result.status,
        })
      }
    } catch (error: unknown) {
      throw ErrorUtil.getError(error)
    }
  }

  async logout(): Promise<void> {
    try {
      const result = await this.httpClient.post<ResponseApi<UserEntity>>('/logout')
      const response = result.data
      if (result.status == 200) {
        if (response.STATUS_CODE != 1) {
          throw new ApiError({
            message: response.MESSAGE!,
            bizCode: response.STATUS_CODE,
            statusCode: result.status,
          })
        }
      } else {
        throw new ApiError({
          message: 'Ocurrio un problema.!',
          bizCode: response.STATUS_CODE,
          statusCode: result.status,
        })
      }
    } catch (error: unknown) {
      throw ErrorUtil.getError(error)
    }
  }
}
